import * as React from 'react';
import {Typography} from 'onboarding-components';

import {HeaderProps} from '../events/types';
import styles from './index.module.styl';

export const SectionHeader = ({title, subTitle}: HeaderProps) => {
  return (
    <div>
      <Typography variant='headingXs' style={{marginTop: 0, marginBottom: 8}}>
        {title}
      </Typography>
      <Typography className={styles.subtitle} variant='bodySm'>
        {subTitle}
      </Typography>
    </div>
  );
};
